var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error_outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16699 12.6453H10.8337V14.312H9.16699V12.6453ZM9.16699 5.97868H10.8337V10.9787H9.16699V5.97868ZM9.99199 1.81201C5.39199 1.81201 1.66699 5.54535 1.66699 10.1453C1.66699 14.7453 5.39199 18.4787 9.99199 18.4787C14.6003 18.4787 18.3337 14.7453 18.3337 10.1453C18.3337 5.54535 14.6003 1.81201 9.99199 1.81201ZM10.0003 16.812C6.31699 16.812 3.33366 13.8287 3.33366 10.1453C3.33366 6.46201 6.31699 3.47868 10.0003 3.47868C13.6837 3.47868 16.667 6.46201 16.667 10.1453C16.667 13.8287 13.6837 16.812 10.0003 16.812Z",
    fill: "#F33535"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarn);
export default __webpack_public_path__ + "static/media/ic_warn.4f18cb16d6027d20c92f2574102c67bc.svg";
export { ForwardRef as ReactComponent };